export default "__VITE_ASSET__CTfSjPcE__"